import { render, staticRenderFns } from "./NewTaxesAnnouncement.vue?vue&type=template&id=50542778&scoped=true"
import script from "./NewTaxesAnnouncement.vue?vue&type=script&lang=js"
export * from "./NewTaxesAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50542778",
  null
  
)

export default component.exports